import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RegionsModel } from 'Pages/referenceBooks'

type State = {
	region: RegionsModel
}

const initialState: State = {
	region: null,
}

export namespace RegionByIpNs {
	export type GetRegion = PayloadAction
	export type SetRegion = PayloadAction<RegionsModel>
}

export const regionByIpSlice = createSlice({
	name: 'regionByIp',
	initialState,
	reducers: {
		getRegion: (state, action: RegionByIpNs.GetRegion) => {},
		setRegion: (state, action: RegionByIpNs.SetRegion) => {
			state.region = action.payload
		},
	},
})
